import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Routes, RouterLink } from '@angular/router';
import { NavigationService } from '../services/navigation.service';
import { MatToolbar } from '@angular/material/toolbar';
import { MatNavList, MatListModule } from '@angular/material/list';
import { NgFor, NgIf } from '@angular/common';
import { HasPermissionDirective } from '@shared/permissions/has-permission.directive';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  imports: [MatToolbar, MatNavList, NgFor, NgIf, HasPermissionDirective, MatListModule, RouterLink, MatIcon, TranslatePipe],
})
export class MenuComponent implements OnInit {
  mainMenuItems: Routes = [];

  @Output()
  navigated = new EventEmitter();

  constructor(private navService: NavigationService) {}

  ngOnInit() {
    this.mainMenuItems = this.navService.getMainMenuItems();
  }
}
